/**
 * アカウント設定ページ用のスクリプト
 */
if (is_route('account.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        account_event_set();
        account_csv_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
 window.account_event_set = function() {

     function createSendData(modalName)
     {
         // 「サポート対象グループ会社」をカンマ区切りの文字列に加工する
         // max_input_vars1000件を超えると、全選択しててもはみ出た分はPOSTされない為
         let settingForm = $('#'+ modalName + '-form');
         var formData = settingForm.serializeArray();
         let data = [];
         $.each(formData, function(i, field) {
             // support_holding_idsは含めない
             if (field.name === 'support_holding_ids[]' || !field.name) {
                 return true;
             }
             data.push({ 'name' : field.name, 'value' : field.value });
         });
         let supportHoldingIdString = $(settingForm).find('[name="support_holding_ids[]"]');
         if (supportHoldingIdString.length) {
             data.push({'name' : 'support_holding_ids', 'value' : supportHoldingIdString.val().join(',')});
         }

         return data;
     }

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], true);
    });

     /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        let settingModalName = 'account-setting-modal';
        let defaultUser = $('#'+ settingModalName +' input[name=default_user_id]');
        let count = $('#'+ settingModalName +' input[name=added_group_count]').val();
        // ユーザーが新規付与される場合以外
        if ($(defaultUser).val().length > 0 && count > 0) {
            let userId = $('#'+ settingModalName +' [name=user_id]').val();
            if ($(defaultUser).val() != userId) {
                // ユーザーの権限グループ初期化確認
                _modal.create_with_data(defaultUser, 'confirm-modal', {
                    'default_user_id': $(defaultUser).val(),
                    'user_id': userId,
                });
                return false;
            }
        }
        let settingForm = $('#'+ settingModalName + '-form');
        let action = settingForm.attr('action');
        let data = createSendData(settingModalName);
        _ajax.post(action, data, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide('#' + settingModalName);
            // 一覧更新
            load_contents();
        }, function(xhr, status, errorThrown) {
            _error.set('#' + settingModalName, xhr, status, errorThrown);
        });
    });

    /*---- 設定の保存時（ユーザーグループ初期化確認） ----*/

    // 設定保存時
    $(document).on('click', '[data-change-confirm-modal]', function () {
        let confirmModalId = create_id($(this).data('change-confirm-modal'));
        let settingModalName = 'account-setting-modal';
        let settingForm = $('#'+ settingModalName + '-form');
        let action = settingForm.attr('action');
        $('#account-setting-modal input[name=initialize_user_group]').val($(this).data('initialize'));
        let data = createSendData(settingModalName);
        _ajax.post(action, data, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // リダイレクト指定時はリダイレクト
            if (results.redirect != null) {
                location.href = results.redirect;
                return;
            }
            // モーダルを閉じる
            _modal.hide(confirmModalId);
            // 一覧更新
            load_contents();
        }, function(xhr, status, errorThrown) {
            _error.set('#' + settingModalName, xhr, status, errorThrown);
            // モーダルを閉じる
            _modal.hide(confirmModalId);
        });
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    // /*---- CSV雛形ダウンロード時 ----*/

    // CSV雛形ダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // ポスト送信を実行
        post(action, datas);
    });

    /*---- CSVアップロード表示時 ----*/

    // CSVアップロード表示時
    $(document).on('click', '#search-form-action_upload', function () {
        // 初期化処理
        $('#account-csv-setting-modal-csv-submit-message').addClass('display-none');
        $('#account-csv-setting-modal-csv-submit-message').empty();
        $('#account-csv-setting-modal-csv-error').addClass('display-none');
        $('#account-csv-setting-modal-csv-error').empty();
        $('#account-csv-setting-modal-csv').val('');
    });

    /*---- CSVアップロード確認時 ----*/

    // CSVアップロード確認時
    $(document).on('change', '#account-csv-setting-modal-csv', function () {
        let modalId = '#account-csv-setting-modal';
        let formId = '#account-csv-setting-modal-form';
        let action = $(formId).data('confirm-action');
        let datas = new FormData($(formId).get(0));
        $(modalId + '-csv-error').addClass('display-none');
        $(modalId + '-csv-error').empty();
        $(modalId + '-csv-submit-message').addClass('display-none');
        $(modalId + '-csv-submit-message').empty();
        $("[data-csv-save-modal]").prop("disabled", true);
        // 送信
        _ajax.file(action, datas, function (results) {
            $(modalId + '-csv-submit-message').removeClass('display-none');
            $(modalId + '-csv-submit-message').text(results.messages[0]);
            $("[data-csv-save-modal]").prop("disabled", false);
        }, function(xhr, status, errorThrown){
            $('#account-csv-setting-modal-csv').val('');
            // フォームにエラーメッセージを配置
            $.each(xhr.responseJSON.errors, function(name, message) {
                $(modalId + '-csv-error').removeClass('display-none');
                $(modalId + '-csv-error').append($('<li></li>').text(message));
            });
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- CSVアップロード時 ----*/

    // 設定表示時
    $(document).on('click', '[data-csv-save-modal]', function () {
        let modalId = '#account-csv-setting-modal';
        let formId = '#account-csv-setting-modal-form';
        let action = $(formId).attr('action');
        let datas = new FormData($(formId).get(0));
        // 送信前にエラーをリセット
        _error.reset()
        // 送信
        _ajax.file(action, datas, function (results) {
            // 一覧取得用のurlにアクセス
            window.location.href = results.url;
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide(modalId);
            // コンテンツの読込
            load_contents();
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.omitted(xhr, status, errorThrown);
        });
    });
}

window.account_csv_event_set = function() {

    /*---- ヘルプボタン押下時 ----*/

    $(document).on('click', '.modal-account-description', function () {
        _modal.show('#account-csv-description-modal');
    });

}
